import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'findByProperty',
  standalone: true
})
export class FindByPropertyPipe implements PipeTransform {
  // Keep the original simple signature but make implementation defensive:
  // - if `list` is an array, use it
  // - if `list` is an object with `entities` array (common store shape), use that
  // - otherwise return null (preserve original behavior of returning nothing when not found)
  transform<T, K extends keyof T>(
    list: readonly T[] | null | undefined,
    property: K,
    value: T[K] | null | undefined
  ): T | null {
    if (!list || !property || value == null) {
      return null;
    }

    let arr: readonly T[] | undefined;

    if (Array.isArray(list)) {
      arr = list;
    } else if (
      list &&
      typeof list === 'object' &&
      Array.isArray((list as unknown as { entities: T[] }).entities)
    ) {
      arr = (list as unknown as { entities: T[] }).entities;
    }

    if (!arr) {
      return null;
    }

    return arr.find(item => item[property] === value) ?? null;
  }
}
